import type { EntityPermission } from '../../../../../services/event/getEvent'

/**
 * Whether the current user may open a player's admin details.
 *
 * Denies by default: no permission object, or one that grants neither `admin`
 * nor `update`, keeps the Player Details entry point hidden. Showing a control
 * whose save would 403 is worse than hiding one the user could have used.
 */
export const resolvePlayerAdminAccess = (
  permission: EntityPermission | null | undefined
): boolean => Boolean(permission?.admin || permission?.update)
